import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const DataRightsCard = () => {
  const rights = [
    {
      icon: 'Eye',
      title: 'Access Your Data',
      description: 'Request a copy of all personal information we have about you.',
      action: 'Request Data'
    },
    {
      icon: 'Edit',
      title: 'Correct Information',
      description: 'Update or correct any inaccurate personal information.',
      action: 'Update Info'
    },
    {
      icon: 'Trash2',
      title: 'Delete Your Data',
      description: 'Request deletion of your personal information from our systems.',
      action: 'Delete Data'
    },
    {
      icon: 'Download',
      title: 'Data Portability',
      description: 'Export your data in a machine-readable format.',
      action: 'Export Data'
    },
    {
      icon: 'Shield',
      title: 'Restrict Processing',
      description: 'Limit how we process your personal information.',
      action: 'Restrict Use'
    },
    {
      icon: 'UserX',
      title: 'Opt-Out',
      description: 'Withdraw consent for marketing communications.',
      action: 'Unsubscribe'
    }
  ];

  return (
    <div className="bg-white rounded-xl p-8 border border-border">
      <h3 className="text-xl font-jakarta font-semibold text-text-primary mb-6 flex items-center">
        <Icon name="Shield" size={24} className="text-primary mr-3" />
        Exercise Your Data Rights
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {rights?.map((right, index) => (
          <div key={index} className="flex items-start space-x-4 p-4 bg-surface rounded-lg border border-border hover:border-primary/20 transition-colors duration-200">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name={right?.icon} size={20} className="text-primary" />
            </div>
            <div className="flex-1">
              <h4 className="font-medium text-text-primary mb-1">{right?.title}</h4>
              <p className="text-sm text-text-secondary mb-3">{right?.description}</p>
              <Button variant="outline" size="sm">
                {right?.action}
              </Button>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-8 p-4 bg-primary/5 rounded-lg border border-primary/20">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={20} className="text-primary mt-0.5" />
          <div>
            <p className="text-sm text-text-primary font-medium mb-1">Response Time</p>
            <p className="text-sm text-text-secondary">
              We will respond to your data rights requests within 30 days. For complex requests, we may extend this period by an additional 60 days with notification.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataRightsCard;